import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subscription, Observable, BehaviorSubject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { DetalheBaseController } from '../../helpers';
import { AcordoService, DevedorService } from '../../services';
import * as _ from 'underscore';

@Component({
  selector: 'app-dividasumarizado',
  templateUrl: './dividasumarizado.component.html',
  styleUrls: ['./dividasumarizado.component.scss']
})
export class DividasumarizadoComponent extends DetalheBaseController implements OnInit {
  @Input() contratoid: number;
  
  subDividas: Subscription;  
  dividas: any = [];
  dividasOriginal: any = [];
  dividasFiltradas: any = [];    
  total: number = 0;  
  multa: number = 0;  
  valorDevido: number = 0;  
  diasEmAtraso: number = 0;  
  valorComMulta: number = 0;
  taxaJuros: number = 0.0061;
  chktodos: boolean =  true;
  verDetalhes: boolean = false;

  @Output() dividaselecionadas: EventEmitter<any> = new EventEmitter<any>();
  @Output() validaSelecao: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() disabledStepConcluir: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  constructor(private router: Router, route: ActivatedRoute, private _acordoService: AcordoService, private _devedor: DevedorService) {
    super(route, _acordoService);    
  }
  
  ngOnInit() {
    this.getDividas(0);    
    this.disabledStepConcluir.emit(false);      
    //seleciona todas as dividas
    this.emitirDividas(this.dividasOriginal, this.dividas);
    this.disabledStepConcluir.emit(this.dividas.length > 0);          
  }    

  getDividas(contratoid: any) {
    this._loading.carregar();    
    this.subDividas = this._devedor.getDividas(contratoid).subscribe(result => {    
      var group = _.chain(result)
          .groupBy(e => e.contratoId)
          .map(e => (e[0].count = e.length, e[0])).value(); 

      this.dividasOriginal = result;
      this.dividas = group.filter(item => item.acordoDivida == null);
      
      if (this.dividas.length == 0)  {
        this.router.navigate(['/app/home']);   
      }
      this.dividas.forEach(element => { element.checked = true;});
      this.emitirDividas(this.dividasOriginal, this.dividas)
      this._loading.fecharTodos();
    });
  }

  dividasSelecionadas(value) {
    this.dividasFiltradas = this.dividas.filter(item => item.checked == true);         
    this.emitirDividas(this.dividasFiltradas, this.dividasFiltradas);  
    this.chktodos = this.dividasFiltradas.length == this.dividas.length;
    this.disabledStepConcluir.emit(this.dividasFiltradas.length > 0); 
  }

  todasDividasSelecionadas(value) {            
    if(value) {
      this.emitirDividas(this.dividasOriginal, this.dividas);
      this.disabledStepConcluir.emit(this.dividas.length > 0); 
    } else {   
      this.validaSelecao.emit(false);  
      this.disabledStepConcluir.emit(false);
      this.total = 0;
    }   
  }

  emitirDividas(dividas, dividaTotalizar) {        
    this.dividaselecionadas.emit(dividas);    
    this.validaSelecao.emit(dividaTotalizar.length > 0);     
    this.totalizarValorDividas(dividaTotalizar);
    this.maiorValorDiasEmAtraso(dividaTotalizar);
    this.calcularJuros(); 
  }  
  
  totalizarValorDividas(dividasFiltradas: any) {
    this.total = dividasFiltradas.reduce((acc, cur) => acc + cur.valorTotal, 0);
  }

  maiorValorDiasEmAtraso(dividasFiltradas: any) {
    this.diasEmAtraso = Math.max.apply(Math, dividasFiltradas.map(function(o) { return o.diasEmAtraso; }));
  }  

  onVerDetalhes(visualizar: boolean){
    this.verDetalhes = visualizar;
  }

  calcularJuros()
  {      
     var taxa = 1.01;
     var meses = this.diasEmAtraso / 30;
     this.valorComMulta  = this.total *  (Math.pow(taxa, meses));
     this.valorDevido = this.valorComMulta ;
  }

  isChecked(value)
  {    
    this.dividas.forEach(element => { element.checked = value.checked;});    
  }  
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/dividasumarizado/dividasumarizado.component.ts